import VerificationDetailsSimpleView from './VerificationDetailsSimpleView'

export default VerificationDetailsSimpleView
